function y(e) {
  "@babel/helpers - typeof";
  return y = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, y(e);
}
function g(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function b(e) {
  g(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || y(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
var C = 6e4;
function I(e, t) {
  return g(2, arguments), b(e).getTime() - b(t).getTime();
}
var E = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
  }
  // Math.trunc is not supported by IE
}, _ = "trunc";
function U(e) {
  return e ? E[e] : E[_];
}
function $(e, t, r) {
  g(2, arguments);
  var n = I(e, t) / C;
  return U(r?.roundingMethod)(n);
}
const T = (e) => {
  if (!e || !e.length || e.split(".").length !== 3)
    return null;
  try {
    return JSON.parse(window.atob(e.split(".")[1]));
  } catch {
    return null;
  }
}, v = (e) => {
  const t = T(e);
  return t ? t.exp * 1e3 < Date.now() : !0;
};
let j;
const N = (e) => {
  j = e;
}, o = (...e) => {
  j && console.log(...e);
}, m = "aegisAccessToken", A = "aegisRefreshToken", i = () => ({
  accessToken: localStorage.getItem(m),
  refreshToken: localStorage.getItem(A)
}), k = (e) => {
  localStorage.setItem(m, e.accessToken), localStorage.setItem(A, e.refreshToken);
}, u = () => {
  localStorage.removeItem(m), localStorage.removeItem(A);
}, M = () => {
  const { accessToken: e } = i();
  return !!e && !!T(e) && !v(e);
}, P = async () => {
  if (o("[Auth] checkAccessToken called"), f)
    return o("[Auth] checkAccessToken: refreshTokenPromise exists, waiting..."), await f, o("[Auth] checkAccessToken: finished waiting for refreshTokenPromise"), M();
  const { accessToken: e } = i();
  return e ? T(e) ? v(e) ? (o("[Auth] checkAccessToken: accessToken is expired, going to refresh..."), h()) : (o("[Auth] checkAccessToken: accessToken is not expired, returning."), !0) : (o("[Auth] checkAccessToken: access token is not a readable JWT"), u(), !1) : (o("[Auth] checkAccessToken - no access token"), !1);
}, R = "dacr-auth-refresh", J = () => {
  const e = navigator.locks;
  return !e || typeof e.request != "function" ? null : e.request.bind(e);
}, x = async () => {
  const e = await c(), { refreshToken: t } = i();
  if (o(`[Auth] refreshAccessToken url: ${e}`), !t)
    return o("[Auth] refreshAccessToken: no refresh token"), u(), !1;
  let r;
  try {
    r = await fetch(`${e}/refresh`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ refreshToken: t }),
      credentials: "include"
    });
  } catch (s) {
    return o("[Auth] refreshAccessToken: network error, keeping tokens", s), !1;
  }
  if (r.status >= 500)
    return o(`[Auth] refreshAccessToken: server error ${r.status}, keeping tokens`), !1;
  if (!r.ok)
    return o(`[Auth] refreshAccessToken: rejected with ${r.status}`), u(), !1;
  const n = await r.json().catch(() => null);
  return !n?.accessToken || !n?.refreshToken ? (o("[Auth] refreshAccessToken: malformed payload"), u(), !1) : (k({
    accessToken: n.accessToken,
    refreshToken: n.refreshToken
  }), !0);
}, F = async () => {
  const e = i().refreshToken, t = J(), r = async () => {
    const { refreshToken: n } = i();
    return n && n !== e ? (o("[Auth] refreshAccessToken: another tab already refreshed"), !0) : x();
  };
  return t ? t(R, r) : r();
}, h = async () => {
  const e = F();
  O(e);
  try {
    return await e;
  } finally {
    O(null);
  }
}, w = 6e4, p = async () => {
  o("[Auth] Init called");
  const { accessToken: e } = i();
  if (!e) {
    console.error("[Auth] init - no access token");
    return;
  }
  const t = T(e);
  if (!t)
    return o("[Auth] init - access token is not a readable JWT"), u();
  const r = (t.exp - t.iat) / 3 * 1e3, n = r / 1e3 / 60;
  o("[Auth] Buffer in ms:", r), o("[Auth] Buffer in min:", n);
  const s = r * 2, a = $(t.exp * 1e3, /* @__PURE__ */ new Date(), {
    roundingMethod: "floor"
  });
  o(`[Auth] Access token expires in ${a} min`), a <= n ? (o("[Auth] Refreshing token"), f ? (o("[Auth] Refreshing token"), await f) : h(), o(`[Auth] Creating setInterval for ${s / w} min`), setInterval(async () => {
    f ? (o("[Auth] Refreshing token (inside if-setInterval) - waiting for refreshTokenPromise"), await f) : h();
  }, s)) : (o(
    `[Auth] Creating setTimeout with ${a - n} min until refresh`
  ), setTimeout(
    async () => {
      o("[Auth] - setTimeout running, refresh token"), f ? (o("[Auth] - setTimeout, waiting for refreshTokenPromise"), await f) : h(), o(`[Auth] - Creating setInterval for ${s / w} min`), setInterval(async () => {
        f ? (o(
          "[Auth] Refreshing token (inside else-setInterval) - waiting for refreshTokenPromise"
        ), await f) : h();
      }, s);
    },
    (a - n) * w
  ));
}, K = async (e) => {
  const t = await c(), r = await fetch(`${t}/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(e),
    credentials: "include"
  }), n = await r.json();
  if (!r.ok)
    throw new Error(n.error || "Sign in failed");
  return n.mfaRequired || n.accessToken && n.refreshToken && (k({
    accessToken: n.accessToken,
    refreshToken: n.refreshToken
  }), await p()), n;
}, W = async (e) => {
  const t = await c(), r = await fetch(`${t}/signup`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(e),
    credentials: "include"
  }), n = await r.json();
  if (!r.ok)
    throw new Error(n.error || "Sign up failed");
  return k({
    accessToken: n.accessToken,
    refreshToken: n.refreshToken
  }), await p(), n;
}, G = async () => {
  const { refreshToken: e } = i(), t = await c();
  e && await fetch(`${t}/logout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ refreshToken: e }),
    credentials: "include"
  }), u();
}, H = async (e) => {
  const t = await c(), r = await fetch(`${t}/forgot-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(e),
    credentials: "include"
  }), n = await r.json();
  if (!r.ok)
    throw new Error(n.error || "Forgot password request failed");
}, Y = async (e) => {
  const t = await c(), r = await fetch(`${t}/reset-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(e),
    credentials: "include"
  }), n = await r.json();
  if (!r.ok)
    throw new Error(n.error || "Reset password failed");
  return n;
}, Q = async (e) => {
  const t = await c(), r = await fetch(`${t}/validate-reset-token`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(e),
    credentials: "include"
  }), n = await r.json();
  if (!r.ok)
    throw new Error(n.error || "Validate reset token failed");
  return n;
}, X = async () => {
  const e = await c(), { accessToken: t } = i();
  if (!t)
    throw new Error("Not authenticated");
  const r = await fetch(`${e}/setup-mfa`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${t}`
    },
    credentials: "include"
  }), n = await r.json();
  if (!r.ok)
    throw new Error(n.error || "Setup MFA failed");
  return n;
}, Z = async (e) => {
  const t = await c(), { accessToken: r } = i(), n = {
    "Content-Type": "application/json"
  };
  r && (n.Authorization = `Bearer ${r}`);
  const s = await fetch(`${t}/verify-mfa`, {
    method: "POST",
    headers: n,
    body: JSON.stringify(e),
    credentials: "include"
  }), a = await s.json();
  if (!s.ok)
    throw new Error(a.error || "Verify MFA failed");
  return a.accessToken && a.refreshToken && (k({
    accessToken: a.accessToken,
    refreshToken: a.refreshToken
  }), await p()), a;
}, ee = async (e) => {
  const t = await c(), { accessToken: r } = i();
  if (!r)
    throw new Error("Not authenticated");
  const n = await fetch(`${t}/disable-mfa`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${r}`
    },
    body: JSON.stringify(e),
    credentials: "include"
  }), s = await n.json();
  if (!n.ok)
    throw new Error(s.error || "Disable MFA failed");
  return s;
}, te = async () => {
  const e = await c(), { accessToken: t } = i();
  if (!t)
    throw new Error("Not authenticated");
  const r = await fetch(`${e}/sessions`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${t}`
    },
    credentials: "include"
  }), n = await r.json();
  if (!r.ok)
    throw new Error(n.error || "Get sessions failed");
  return n;
}, ne = async (e) => {
  const t = await c(), { accessToken: r } = i();
  if (!r)
    throw new Error("Not authenticated");
  const n = await fetch(`${t}/revoke-session`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${r}`
    },
    body: JSON.stringify(e),
    credentials: "include"
  }), s = await n.json();
  if (!n.ok)
    throw new Error(s.error || "Revoke session failed");
  return s;
}, re = async () => {
  const e = await c(), { accessToken: t } = i();
  if (!t)
    throw new Error("Not authenticated");
  const r = await fetch(`${e}/revoke-all-sessions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${t}`
    },
    credentials: "include"
  }), n = await r.json();
  if (!r.ok)
    throw new Error(n.error || "Revoke all sessions failed");
  return n;
}, B = (e = 64) => {
  const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789._~-", r = crypto.getRandomValues(new Uint8Array(e));
  return Array.from(r).map((n) => t[n % t.length]).join("");
}, V = async (e) => {
  const r = new TextEncoder().encode(e), n = await crypto.subtle.digest("SHA-256", r);
  return btoa(String.fromCharCode(...new Uint8Array(n))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};
let S = null;
const D = (e) => {
  S = e;
}, z = () => S, L = () => {
  S = null;
}, oe = async (e) => {
  const t = B(), r = await V(t), n = crypto.randomUUID();
  D(t);
  const s = new URLSearchParams({
    client_id: e.clientId,
    response_type: "code",
    redirect_uri: e.redirectUri,
    code_challenge: r,
    code_challenge_method: "S256",
    state: n,
    ...e.scope && { scope: e.scope }
  }), l = `${await c()}/oauth/authorize?${s.toString()}`;
  return o(`[Auth] OAuth flow started, auth URL: ${l}`), { authUrl: l, codeVerifier: t };
}, se = async (e, t, r) => {
  const n = z();
  if (!n)
    throw new Error("No code verifier found. OAuth flow was not started properly.");
  const s = await c(), a = await fetch(`${s}/oauth/token`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      grant_type: "authorization_code",
      client_id: r,
      code: e,
      redirect_uri: t,
      code_verifier: n
    }),
    credentials: "include"
  }), l = await a.json();
  if (L(), !a.ok || l.error)
    throw new Error(l.error_description || l.error || "Token exchange failed");
  return k({
    accessToken: l.access_token,
    refreshToken: l.refresh_token
  }), await p(), o("[Auth] OAuth tokens received and stored successfully"), {
    accessToken: l.access_token,
    refreshToken: l.refresh_token,
    userId: l.user_id,
    email: l.email
  };
};
let f = null;
const O = (e) => {
  f = e;
};
let d = "";
const c = async () => d || new Promise((e) => {
  const t = setInterval(() => {
    d && (clearInterval(t), e(d));
  }, 50);
}), ae = async (e) => (N(e.debug || !1), d = e.url, o("[Auth] setupAuth called"), await P() && await p(), q()), q = () => {
  const { accessToken: e, refreshToken: t } = i();
  return !!(e && t);
};
export {
  d as apiUrl,
  P as checkAccessToken,
  ee as disableMfa,
  se as exchangeCodeForTokens,
  H as forgotPassword,
  c as getApiUrl,
  te as getSessions,
  i as getTokens,
  q as isSignedIn,
  f as refreshTokenPromise,
  Y as resetPassword,
  re as revokeAllSessions,
  ne as revokeSession,
  O as setRefreshTokenPromise,
  ae as setupAuth,
  X as setupMfa,
  K as signin,
  G as signout,
  W as signup,
  oe as startOAuthFlow,
  Q as validateResetToken,
  Z as verifyMfa
};
